<div class="landing-container">
  <div class="content">
    <img src="../../assets/images/logo-cannonball@2x.png" alt="" width="300">
    <h1>Project Management Portal</h1>

    <ng-container *ngIf="auth.user$ | async as user; else loginButton">
      <div class="user-info">
        <img [src]="user.photoURL" alt="Profile picture" *ngIf="user.photoURL">
        <p>Welcome, {{ user.displayName }}</p>
        <button (click)="signOut()" class="btn-secondary">Sign Out</button>
      </div>
    </ng-container>

    <div *ngIf="auth.authError" class="auth-error">
      {{ auth.authError }}
    </div>

    <ng-template #loginButton>
      <button (click)="signIn()">Sign in with Google</button>
    </ng-template>
  </div>
</div>